// frontend/src/GoogleLoginButton.js
import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from './AuthProvider'; // Import useAuth hook

function GoogleLoginButton({ onLoginFailure }) {
  const { handleLogin } = useAuth();

  const handleGoogleSuccess = async (credentialResponse) => {
    if (!credentialResponse.credential) {
      console.error("Google login success but no credential (ID token) received.");
      onLoginFailure("No Google credential received from Google.");
      return;
    }

    try {
      const res = await fetch("/api/auth/google", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id_token: credentialResponse.credential }),
      });

      const data = await res.json();

      if (!res.ok) {
        const errorDetail = data.detail || `Google login failed with status ${res.status}`;
        console.error("Backend response error:", errorDetail);
        throw new Error(errorDetail);
      }

      handleLogin(
        data.token,
        data.user_email || data.user_name,
        data.user_name,
        data.user_role || "user"
      );

    } catch (error) {
      console.error("Error during backend verification of Google token:", error);
      onLoginFailure(error.message || "An unknown error occurred during Google login.");
    }
  };

  const handleGoogleError = (error) => {
    console.error("Google Login Failed:", error);
    onLoginFailure("Google login failed. See console for details.");
  };

  return (
    <GoogleLogin
      onSuccess={handleGoogleSuccess}
      onError={handleGoogleError}
      useOneTap
    />
  );
}

export default GoogleLoginButton;

